export default function WarehouseToFirstLocation(props) {
  return (
    <svg
      {...props}
      width="30"
      height="15"
      viewBox="0 0 94 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_10)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M76 9C76 4.02975 80.0297 0 85 0C89.9703 0 94 4.02975 94 9C94 10.9571 93.3584 12.753 92.2919 14.2238C92.2832 14.2398 92.2779 14.2567 92.2726 14.2736C92.2663 14.2937 92.26 14.3138 92.248 14.3321L86.248 23.3321C85.9697 23.7495 85.501 24 85 24C84.499 24 84.0303 23.7495 83.752 23.3321L77.752 14.3321C77.7402 14.3139 77.734 14.294 77.7276 14.274C77.7223 14.257 77.7169 14.2399 77.7081 14.2238C76.6416 12.753 76 10.9571 76 9ZM85 13.38C87.419 13.38 89.38 11.419 89.38 9C89.38 6.58099 87.419 4.62 85 4.62C82.581 4.62 80.62 6.58099 80.62 9C80.62 11.419 82.581 13.38 85 13.38Z"
          fill="white"
        />
        <path
          d="M85.7521 6.63636V11H84.8295V7.51207H84.804L83.8047 8.13849V7.32031L84.8849 6.63636H85.7521Z"
          fill="white"
        />
      </g>
      <g clipPath="url(#clip1_1_10)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 23.5V10.5C4 9.9477 4.44772 9.49999 5 9.49999H19C19.5523 9.49999 20 9.9477 20 10.5V23.5H4ZM18 11.5H6V23.5H18V11.5ZM1 23.5C0.447715 23.5 0 23.0523 0 22.5V7.1439C0 6.35962 0.458406 5.64771 1.17239 5.32317L11.1724 0.777722C11.6982 0.538692 12.3018 0.538692 12.8276 0.777722L22.8276 5.32317C23.5416 5.64771 24 6.35962 24 7.1439V22.5C24 23.0523 23.5523 23.5 23 23.5H1ZM6 13.5H18V15.5H6V13.5ZM6 21.5H18V23.5H6V21.5ZM6 17.5H18V19.5H6V17.5Z"
          fill="white"
        />
      </g>
      <line
        x1="31"
        y1="14.5"
        x2="69"
        y2="14.5"
        stroke="white"
        strokeWidth="3"
      />
      <defs>
        <clipPath id="clip0_1_10">
          <rect width="18" height="24" fill="white" transform="translate(76)" />
        </clipPath>
        <clipPath id="clip1_1_10">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
